'use es6';

import { getFile, getLocalId } from 'conversations-internal-schema/file-upload/operators/fileUploadGetters';
import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
import { getSessionId } from '../../selectors/widgetDataSelectors/getSessionId';
import { fetchAttachmentUploadUrlClient } from '../clients/fetchAttachmentUploadUrlClient';
import { uploadAttachmentClient } from '../clients/uploadAttachmentClient';
import { createFormDataForAttachment } from '../util/createFormDataForAttachment';
import { attachmentUploadStart } from '../../file-uploads/actions/attachmentUploadStart';
import { attachmentUploadComplete } from '../../file-uploads/actions/attachmentUploadComplete';
import { INVALID_FILE_TYPE, UPLOAD_ERROR } from '../../file-uploads/constants/attachmentErrors';
import { handleAttachmentUploadProgress } from './handleAttachmentUploadProgress';
import { attachmentError } from '../../file-uploads/actions/attachmentError';
import { FILE_MANAGER_API_PREFIX } from '../constants/fileUploadsConstants';
export const uploadAttachment = ({
  attachment,
  threadId
}) => (dispatch, getState) => {
  const uploadStartTimestamp = Date.now();
  dispatch(attachmentUploadStart({
    attachment,
    threadId
  }));
  const sessionId = getSessionId(getState());
  const localId = getLocalId(attachment);
  const file = getFile(attachment);
  const formData = createFormDataForAttachment({
    file
  });
  return fetchAttachmentUploadUrlClient({
    sessionId,
    threadId
  }).then(({
    uploadUrl
  }) => uploadAttachmentClient({
    formData,
    onProgress: ({
      loaded,
      total
    }) => {
      dispatch(handleAttachmentUploadProgress({
        localId,
        threadId,
        loaded,
        total
      }));
    },
    uploadUrl: `${FILE_MANAGER_API_PREFIX}/${uploadUrl}`
  })).then(({
    objects: [uploadedFile]
  }) => {
    const uploadCompleteTimestamp = Date.now();
    dispatch(attachmentUploadComplete({
      localId,
      threadId,
      fileId: uploadedFile.id,
      uploadedFile
    }));
    dispatch(trackInteraction('attached-file', {
      action: 'attached file',
      'attachment-type': uploadedFile.extension,
      'attachment-size-bytes': file.size,
      'upload-time-ms': uploadCompleteTimestamp - uploadStartTimestamp
    }));
  }).catch(err => {
    var _err$responseJSON;
    if (err !== null && err !== void 0 && (_err$responseJSON = err.responseJSON) !== null && _err$responseJSON !== void 0 && (_err$responseJSON = _err$responseJSON.message) !== null && _err$responseJSON !== void 0 && _err$responseJSON.includes('not allowed')) {
      dispatch(attachmentError(INVALID_FILE_TYPE, threadId));
      dispatch(trackInteraction('failed-to-attach-file', {
        action: 'failed to attach file',
        'failure-type': 'invalid file type'
      }));
    } else {
      dispatch(attachmentError(UPLOAD_ERROR, threadId));
      dispatch(trackInteraction('failed-to-attach-file', {
        action: 'failed to attach file',
        'failure-type': 'upload error'
      }));
    }
  });
};